import React from 'react'
import { Link } from 'react-router-dom'
import { fileUrl } from '../../eventsPublic/functions/fileUrl'
import { jobPublicPath } from '../../lib/functions/jobPublicPath'
import { bildMasse } from '../../lib/functions/bildMasse'

// Bilder in Listen laden verzoegert (loading="lazy", Audit 2026-10-07, S5):
// 20 Logos je Seite, die meisten unter der Falz. Gilt fuer alle Listenbilder
// der Apps; einzelne Bilder ueber der Falz (Firmenlogo der Anzeige) nicht.
//
// Trefferliste der Stellenangebote: Logo links, Titel und Firma mittig, Art
// rechts in Versalien. Das Logo ist Schmuck (alt=""): der Firmenname steht als
// Text im selben Verweis, sonst laese ihn der Screenreader zweimal (#236).
// Dieselbe Liste steht in der Übersicht und am Ende einer
// Anzeige unter „Alle Stellenangebote von …“ (Live-Vorlage).
const JobsTable = ({ jobs }) => (
    <ul className="jobs-cards">
        {jobs.map(job => (
            <li key={job.slug} className="jobs-card">
                <Link className="jobs-card-inner" to={jobPublicPath(job.slug)}>
                    <span className="jobs-card-logo">
                        {job.company.logo && <img src={fileUrl(job.company.logo.fileId)} alt="" loading="lazy" decoding="async" {...bildMasse(job.company.logo)} />}
                    </span>
                    <span className="jobs-card-text">
                        <span className="jobs-card-title">{job.title}</span>
                        <span className="jobs-card-company">{job.company.name}</span>
                    </span>
                    <span className="jobs-card-type">{job.jobType}</span>
                </Link>
            </li>
        ))}
    </ul>
)

export default JobsTable
